import { FormattedMessage } from "react-intl";

import { Button } from "@ps-design-system/components/Button";
import { Text } from "@ps-design-system/components/Text";
import ChefIcon from "@ps-design-system/icons/Chef/Chef20";
import LoftIcon from "@ps-design-system/icons/Loft/Loft20";

type SpacesServicesFooterProps = {
  activeFilter: string;
};

const SpacesServicesFooter = ({ activeFilter }: SpacesServicesFooterProps) => {
  return (
    <div className="tw-block md:tw-hidden tw-fixed tw-bottom-0 tw-left-0 tw-bg-base-white tw-w-full">
      <hr className="tw-m-0" />
      <div className="tw-flex tw-items-center tw-justify-center tw-py-24 tw-px-32">
        <div className="tw-flex md:tw-hidden tw-items-center tw-justify-center tw-gap-8 tw-w-full">
          {"services" !== activeFilter && (
            <Button
              href="/your-space"
              className={"spaces" === activeFilter ? "tw-w-full" : ""}
              prefix={<LoftIcon />}
            >
              <Text typeface="body-2-m">
                <FormattedMessage
                  id="vendor.edit.add_a_space"
                  defaultMessage="Add a space"
                />
              </Text>
            </Button>
          )}
          {"spaces" !== activeFilter && (
            <Button
              className={"services" === activeFilter ? "tw-w-full" : ""}
              prefix={<ChefIcon />}
              href="https://hosts.trypeerspace.com/peerspace-vendor-onboarding"
            >
              <Text typeface="body-2-m">
                <FormattedMessage
                  id="vendor.edit.add_a_service"
                  defaultMessage="Add a service"
                />
              </Text>
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SpacesServicesFooter;
